import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {Subscription} from 'rxjs';
import {IPaginatedService} from '../../service/iPaginatedService';
import {AbstractFindManyPaginatedService} from '../../service/v2/service/findmany/abstractFindManyPaginated.service';
import {IonCard, IonHeader} from '@ionic/angular';

@Component({
    selector: 'app-card',
    templateUrl: './card.component.html',
})
export class CardComponent<T> implements OnChanges, OnInit {

    @Input() title = '';
    @Input() value = '';
    @Input() iconName;
    @Input() margin = true;
    @Input() contentPadding = true;
    @Input() titleColor = 'primary';
    @Input() loading = false;
    @Input() expandable = false;
    @Input() expanded = true;
    @Input() showTotalItems = true;
    @Input() hasRawTitle = false;
    @Input() badge: number;
    @Input() backgroundColor: string;

    @Input() paginatedService: IPaginatedService<T> | AbstractFindManyPaginatedService<any, T>;
    @Input() hideRefreshButton = false;
    @Output() _onClickIcon = new EventEmitter<void>();
    @Output() expandedEvent = new EventEmitter<boolean>();


    @Input() itemCount = undefined;
    subscription: Subscription;

    ngOnInit(): void {
        if (this.expanded === false) {
            this.expandable = true;
        }
    }



    ngOnChanges(changes: SimpleChanges): void {
        if (changes['paginatedService']) {
            this.subscription?.unsubscribe();
            if (this.paginatedService) {
                this.subscription = this.paginatedService.page$.subscribe(value => {
                    this.itemCount = value ? value.totalElements : undefined;
                });
            }
        }
    }
    refresh() {
        this.paginatedService.refresh();
    }

    onExpanded() {
        this.expanded = !this.expanded;
        this.expandedEvent.emit(this.expanded);
    }
}
